var thankyouPage =
  (document.querySelector("body.woocommerce-order-received") as HTMLElement) ||
  null;

if (thankyouPage) {
  document.addEventListener(
    "DOMContentLoaded",
    function () {
      let woltTrackingLink =
        (document.getElementById(
          "woocommerce__wolt-link"
        ) as HTMLAnchorElement) || null;

      if (woltTrackingLink && woltTrackingLink.getAttribute("href") == "") {
        //Fetch Wolt Link
        fetchWoltLink();
      }
    },
    false
  );

  function fetchWoltLink() {
    let orderDetails =
      (document.getElementById("customOrderCall") as HTMLInputElement) || null;
    let orderDetailsJSON = orderDetails?.value;

    if (orderDetailsJSON) {
      const orderId = JSON.parse(orderDetailsJSON).order_id;
      const ajaxData = (window as any).njamito_ajax;

      fetchWoltCall(orderId, ajaxData);
    }
  }

  function displayWoltLink(woltlink) {
    document.querySelector(".loader-small")?.remove();
    let woltTrackingLink =
      (document.getElementById(
        "woocommerce__wolt-link"
      ) as HTMLAnchorElement) || null;
    if (woltTrackingLink) {
      woltTrackingLink.setAttribute("href", woltlink);
      woltTrackingLink.innerHTML = woltlink;
    }
  }

  //Fetch Wolt Call function - it's a separate function to order to have it in recursion
  function fetchWoltCall(orderId, ajaxData) {
    return new Promise((resolve) => {
      if ((window as any).njamito_ajax) {
        let data = new FormData();
        data.append("action", "njamito_get_wolt_link");
        data.append("orderId", orderId);
        data.append("nonce", ajaxData.nonce);

        fetch(ajaxData.ajax_url, {
          method: "POST",
          body: data,
        })
          .then((response) => {
            return response.json();
          })
          .then((jsonResponse) => {
            if (!jsonResponse.success) {
            }

            if (jsonResponse.success) {
              if (jsonResponse.data.wolt_tracking_url == "") {
                //If Wolt link is not available, call itself again
                fetchWoltCall(orderId, ajaxData);
              } else {
                displayWoltLink(jsonResponse.data.wolt_tracking_url);
              }
            }
          });
      }
    });
  }
}
